module.exports = __webpack_public_path__ + "static/media/apartment15.ecbd9efd.jpg";